module.exports = __webpack_public_path__ + "static/img/clipe_bateria-1.69e327d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/clipe_bateria-1.svg
// module id = DOH2
// module chunks = 0